(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["unitus-product-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-gallery')) {
  customElements.define(
    'product-gallery',
    class ProductGallery extends HTMLElement {
      connectedCallback() {
        window.UnitusMainProduct.init()
      }
    })
  }
  } catch(e) { console.error(e); }
})();

})();
